/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { PreloaderIcon } from '@coursera/cds-icons';

const styles = {
  spinning: css`
    animation: var(--labs-animation-spin);
  `,
};

/**
 * @deprecated use CDS loading Button prop or LoadingSection component instead
 */
export function Spinner() {
  return <PreloaderIcon css={styles.spinning} />;
}

export default Spinner;
